module.exports = __webpack_public_path__ + "img/unknown.8259d80e.svg";